import React from "react";
import StoreListTable from "../StoreListTable";
import Header from "@commons/header";
import Row from "@components/row";
import SubscriptionCard from "@commons/cards/subscription";
import TransactionCard from "@commons/cards/transaction";
import Tab from "@components/tabs";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";

const StoreList = () => {
  const { items: stores, totalItems } = useSelector(
    (state: RootState) => state.stores
  );
  const { data: modules } = useSelector((state: RootState) => state.modules);

  const tabItems: any = modules.map((module) => ({
    label: module.name,
    component: StoreListTable,
    props: { moduleId: module.id, type: "verified" },
  }));

  const subscriptionData = [
    {
      count: totalItems,
      title: "Total Store",
      icon: "/pngs/subscription/subscribed-user.png",
      status: "subscribed",
    },
    {
      count: stores.filter((s) => s.isActive).length.toString(),
      title: "Active Store",
      icon: "/pngs/subscription/active-user.png",
      status: "active",
    },
    {
      count: stores.filter((s) => !s.isActive).length.toString(),
      title: "Inactive Store",
      icon: "/pngs/subscription/expired-user.png",
      status: "expired",
    },
    {
      count: "0",
      title: "Newly Joined users",
      icon: "/pngs/subscription/expired-soon.png",
      status: "expiring",
    },
  ];
  return (
    <>
      <Header title="Stores" />
      <br />
      <Row>
        {subscriptionData.map((item, i) => (
          <SubscriptionCard key={i} item={item} />
        ))}
      </Row>
      <br />
      <TransactionCard />
      <br />
      <Tab items={tabItems} fitContent />
    </>
  );
};

export default StoreList;
